// extracted by css-extract-rspack-plugin
export default {"dropboxDownload":"qJx629M2nBshkhUM","item":"Kz6_6llOLv0W6N5K","dropboxButton":"Q9CFsXLwfc1_WaA8"};